import { WebPortalService } from "../resource";

const EventLogModule = {
  namespaced: true,
  state: {
    sessions: [],
    sessionEvents: [],
    total: 0,
    page: 1,
    perPage: 20
  },
  mutations: {
    SET_SESSIONS(state, payload) {
      state.sessions = payload.data || [];
      state.total = payload.total || 0;
      state.page = payload.page || 1;
      state.perPage = payload.perPage || 20;
    },
    SET_SESSION_EVENTS(state, data) {
      state.sessionEvents = data;
    }
  },
  actions: {
    async listSessions({ commit }, params) {
      try {
        const resp = await WebPortalService.EventLogListV4(params);
        commit("SET_SESSIONS", {
          data: resp.data.Data || [],
          total: resp.data.Total || 0,
          page: resp.data.Page || 1,
          perPage: resp.data.PerPage || 20
        });
        return resp;
      } catch (err) {
        commit("SET_SESSIONS", { data: [], total: 0, page: 1, perPage: 20 });
        throw err;
      }
    },
    async listSessionEvents({ commit }, params) {
      try {
        const resp = await WebPortalService.EventLogSessionV4(params);
        commit("SET_SESSION_EVENTS", resp.data.Data || []);
        return resp;
      } catch (err) {
        commit("SET_SESSION_EVENTS", []);
        throw err;
      }
    },
    clearSessionEvents({ commit }) {
      commit("SET_SESSION_EVENTS", []);
    }
  },
  getters: {
    getSessions(state) {
      return state.sessions;
    },
    getSessionEvents(state) {
      return state.sessionEvents;
    },
    getTotal(state) {
      return state.total;
    },
    getPage(state) {
      return state.page;
    },
    getPerPage(state) {
      return state.perPage;
    }
  }
};

export default EventLogModule;
